
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class SalaryComponentDialog extends _Ext.DialogBase<SalaryComponentRow, any> {
        protected getFormKey() { return SalaryComponentForm.formKey; }
        protected getIdProperty() { return SalaryComponentRow.idProperty; }
        protected getLocalTextPrefix() { return SalaryComponentRow.localTextPrefix; }
        protected getNameProperty() { return SalaryComponentRow.nameProperty; }
        protected getService() { return SalaryComponentService.baseUrl; }
        protected getDeletePermission() { return SalaryComponentRow.deletePermission; }
        protected getInsertPermission() { return SalaryComponentRow.insertPermission; }
        protected getUpdatePermission() { return SalaryComponentRow.updatePermission; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new SalaryComponentForm(this.idPrefix);

    }
}